import { parseDownloadLink } from './downloadLinkBaseParser';
import { type TagParser } from './tagParser';
import { ParserRegistry } from './parserRegistry';

class DownloadLinkSimpelTagParser implements TagParser {
  tag = 'downloadlinksimpel_start';

  parse(text: string) {
    const endTag = 'downloadlinksimpel_end';
    return parseDownloadLink(text, endTag);
  }
}

ParserRegistry.register(new DownloadLinkSimpelTagParser());
